import { render, staticRenderFns } from "./BulkServiceBundleChange.vue?vue&type=template&id=f8727162&"
import script from "./BulkServiceBundleChange.vue?vue&type=script&lang=js&"
export * from "./BulkServiceBundleChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BulkServiceBundleChange.vue"
export default component.exports